<template>
  <div class="all-orders-container">
    <el-container>
      <el-main>
        <div class="header">
          <h1>校内订单</h1>
          <button class="el-button el-button--primary" @click="exportToExcel">
            导出表格
          </button>
        </div>
        <div class="table-container">
          <!-- 订单列表 -->
          <el-table :data="paginatedOrders" style="width: 100%" border>
            <el-table-column
              prop="orderId"
              label="订单编号"
              width="120"
            ></el-table-column>
            <el-table-column
              prop="createTime"
              label="创建时间"
              width="234"
            ></el-table-column>
            <el-table-column prop="status" label="订单状态" width="200">
              <template #header>
                <div style="display: flex; align-items: center">
                  <span>订单状态</span>
                  <el-select
                    v-model="statusFilter"
                    placeholder="全部"
                    clearable
                    size="small"
                    style="margin-left: 10px; width: 100px"
                    @change="handleFilter"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option label="待支付" value="unpaid"></el-option>
                    <el-option label="打印中" value="printing"></el-option>
                    <el-option label="配送中" value="delivering"></el-option>
                    <el-option label="已完成" value="completed"></el-option>
                    <el-option label="已取消" value="cancelled"></el-option>
                  </el-select>
                </div>
              </template>
              <template #default="scope">
                <el-tag :type="getStatusType(scope.row.status)">
                  {{ getStatusText(scope.row.status) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="printType" label="打印类型" width="100">
              <template #default="scope">
                {{ scope.row.printType === "black" ? "黑白" : "彩色" }}
              </template>
            </el-table-column>
            <el-table-column prop="copies" label="打印份数" width="100">
              <template #default="scope"> {{ scope.row.copies }} 份 </template>
            </el-table-column>
            <el-table-column label="实付金额" width="120">
              <template #default="scope">
                <span style="color: #000000; font-weight: 500">
                  ¥{{ scope.row.pay.toFixed(2) }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="200">
              <template #default="scope">
                <div class="operation-buttons">
                  <el-button size="small" @click="viewOrderDetail(scope.row)"
                    >查看详情</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页 -->
          <div class="pagination-container">
            <el-pagination
              :current-page="currentPage"
              :page-size="pageSize"
              :page-sizes="[10, 20, 50, 100]"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalOrders"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </div>

        <!-- 订单详情弹窗 -->
        <el-dialog
          title="订单详情"
          v-model="detailDialogVisible"
          width="70%"
          top="5vh"
          :destroy-on-close="true"
          :close-on-click-modal="false"
          class="order-detail-dialog"
        >
          <div v-if="currentOrder" class="order-detail">
            <el-descriptions :column="2" border>
              <el-descriptions-item label="订单编号">{{
                currentOrder.orderId
              }}</el-descriptions-item>
              <el-descriptions-item label="创建时间">{{
                currentOrder.createTime
              }}</el-descriptions-item>
              <el-descriptions-item label="用户名">{{
                currentOrder.userName
              }}</el-descriptions-item>
              <el-descriptions-item label="用户手机号">{{
                currentOrder.phone
              }}</el-descriptions-item>
              <el-descriptions-item label="订单状态">
                <el-tag :type="getStatusType(currentOrder.status)">
                  {{ getStatusText(currentOrder.status) }}
                </el-tag>
              </el-descriptions-item>
              <el-descriptions-item label="打印类型">
                {{ currentOrder.printType === "black" ? "黑白" : "彩色" }}
              </el-descriptions-item>
              <el-descriptions-item
                label="翻页方式"
                v-if="currentOrder.printSide === '双面'"
              >
                {{ currentOrder.method }}
              </el-descriptions-item>
              <el-descriptions-item label="打印面数">
                {{ currentOrder.page }}
              </el-descriptions-item>

              <el-descriptions-item label="装订方式">
                {{ currentOrder.binding }}
              </el-descriptions-item>
              <el-descriptions-item label="纸张大小">
                {{ currentOrder.paperSize }}
              </el-descriptions-item>
              <el-descriptions-item label="纸张材质">
                {{ currentOrder.paperMaterial }}
              </el-descriptions-item>
              <el-descriptions-item label="纸张厚度">
                {{ currentOrder.thick }}
              </el-descriptions-item>
              <el-descriptions-item label="封面内容">
                {{
                  currentOrder.fm_content
                    ? currentOrder.fm_content === "空白"
                      ? "空白封面"
                      : currentOrder.fm_content === "首页"
                      ? "文件首页为封面"
                      : "文件首尾为封面封底"
                    : "不添加封面"
                }}
              </el-descriptions-item>
              <el-descriptions-item
                label="封面类型"
                v-if="currentOrder.fm_content"
              >
                {{ currentOrder.fm_type }}
              </el-descriptions-item>
              <!-- <el-descriptions-item
                label="封面工艺"
                v-if="currentOrder.fm_content"
              >
                {{ currentOrder.fm_method }}
              </el-descriptions-item> -->
              <el-descriptions-item label="打印份数">
                {{ currentOrder.copies }}
              </el-descriptions-item>
              <el-descriptions-item label="配送地址">{{
                currentOrder.deliveryAddress
              }}</el-descriptions-item>
              <el-descriptions-item label="备注">{{
                currentOrder.note
              }}</el-descriptions-item>
              <!-- <el-descriptions-item label="配送时间">{{
                currentOrder.deliveryTime
              }}</el-descriptions-item> -->
              <el-descriptions-item label="总价">
                ¥{{ currentOrder.totalPrice.toFixed(2) }}
              </el-descriptions-item>
              <el-descriptions-item label="优惠券使用">
                <span v-if="currentOrder.coupon_info">
                  已使用优惠券 ({{ currentOrder.coupon_info.code }})
                </span>
                <span v-else>未使用优惠券</span>
              </el-descriptions-item>
              <el-descriptions-item label="实付金额">
                <span style="color: #f56c6c; font-weight: 500">
                  ¥{{ currentOrder.pay.toFixed(2) }}
                </span>
              </el-descriptions-item>
            </el-descriptions>

            <!-- 文件列表 -->
            <div class="file-list">
              <h3>文件操作</h3>
              <div class="file-operations">
                <el-button
                  size="small"
                  type="primary"
                  @click="downloadFile(currentOrder.id)"
                >
                  下载打印文件
                </el-button>
                <el-button
                  size="small"
                  type="success"
                  @click="exportOrderReceipt(currentOrder)"
                >
                  导出小票
                </el-button>
              </div>
            </div>
          </div>
        </el-dialog>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import * as XLSX from "xlsx";
export default {
  name: "AllOrders",
  data() {
    return {
      statusFilter: "", // 状态筛选
      notificationSound: new Audio("/notification.mp3"),
      orderList: [],
      currentPage: 1,
      pageSize: 10,
      detailDialogVisible: false,
      currentOrder: null,
      lastOrderCount: 0,
      refreshInterval: null,
      userId: null,
    };
  },
  computed: {
    filteredOrders() {
      let result = [...this.orderList];

      // 状态筛选
      if (this.statusFilter) {
        result = result.filter((order) => order.status === this.statusFilter);
      }
      // 前端按ID降序排序
      result.sort((a, b) => b.id - a.id);
      return result;
    },
    paginatedOrders() {
      const startIndex = (this.currentPage - 1) * this.pageSize;
      const endIndex = startIndex + this.pageSize;
      return this.filteredOrders.slice(startIndex, endIndex);
    },
    totalOrders() {
      return this.filteredOrders.length;
    },
  },
  mounted() {
    // 初始化音频
    this.initAudio();
    this.userId = localStorage.getItem("userId");
    console.log(this.userId);

    this.lastOrderCount = 0;
    this.fetchOrders();

    // 每分钟自动刷新订单列表
    this.refreshInterval = setInterval(() => {
      this.fetchOrders();
    }, 6000);
  },
  beforeUnmount() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  },
  methods: {
    exportToExcel() {
      // 创建工作簿
      const wb = XLSX.utils.book_new();

      const exportData = this.orderList.map((order) => ({
        订单ID: order.orderId,
        用户名: order.userName,
        手机号: order.phone,
        创建时间: order.createTime,
        状态: order.status,
        打印类型: order.printType,
        打印面数: order.printSide,
        纸张尺寸: order.paperSize,
        纸张材质: order.paperMaterial,
        纸张厚度: order.thick,
        份数: order.copies,
        配送地址: order.deliveryAddress,
        总价: order.totalPrice,
        装订方式: order.binding,
        支付方式: order.method,
        封面内容: order.fm_content,
        封面类型: order.fm_type,
        缩印: order.suoyin,
        支付状态: order.pay,
        备注: order.note,
      }));

      // 创建工作表
      const ws = XLSX.utils.json_to_sheet(exportData);

      // 设置列宽
      const wscols = [
        { wch: 15 }, // 订单ID
        { wch: 10 }, // 用户名
        { wch: 15 }, // 手机号
        { wch: 20 }, // 创建时间
        { wch: 8 }, // 状态
        { wch: 10 }, // 打印类型
        { wch: 8 }, // 打印面
        { wch: 12 }, // 纸张尺寸
        { wch: 12 }, // 纸张材质
        { wch: 8 }, // 份数
        { wch: 30 }, // 配送地址
        { wch: 10 }, // 总价
        { wch: 12 }, // 装订方式
        { wch: 10 }, // 支付方式
        { wch: 20 }, // 封面内容
        { wch: 10 }, // 封面类型
        { wch: 10 }, // 索引
        { wch: 10 }, // 支付状态
        { wch: 30 }, // 备注
      ];
      ws["!cols"] = wscols;

      // 添加工作表到工作簿
      XLSX.utils.book_append_sheet(wb, ws, "订单数据");

      // 导出文件
      const fileName = `订单数据_${
        new Date().toISOString().split("T")[0]
      }.xlsx`;
      XLSX.writeFile(wb, fileName);
    },
    // 播放提示音，带有重试机制
    async playNotificationSound() {
      try {
        // 确保音频已重置
        this.notificationSound.currentTime = 0;

        // 尝试播放
        const playPromise = this.notificationSound.play();

        // 处理异步播放结果
        if (playPromise !== undefined) {
          playPromise
            .then(() => {
              console.log("提示音播放成功");
            })
            .catch((error) => {
              console.warn("提示音播放失败，尝试重新加载:", error);

              // 重新加载并尝试再次播放
              this.notificationSound.load();
              setTimeout(() => {
                this.notificationSound.play().catch((e) => {
                  console.error("重试播放失败:", e);
                  this.$message.warning({
                    message: "有新订单，但提示音播放失败，请检查浏览器设置",
                    duration: 3000,
                  });
                });
              }, 1000);
            });
        }
      } catch (error) {
        console.error("播放提示音出错:", error);
      }
    },

    initAudio() {
      // 重新创建Audio对象，确保路径正确
      this.notificationSound = new Audio("/notification.mp3");

      // 预加载音频
      this.notificationSound.load();

      // 监听音频加载错误
      this.notificationSound.onerror = (error) => {
        console.error("提示音加载失败:", error);
        this.$message.error("提示音加载失败，新订单通知可能无法正常工作");
      };

      // 音频加载完成回调
      this.notificationSound.oncanplaythrough = () => {
        console.log("提示音加载成功，准备就绪");
      };
    },

    getStatusType(status) {
      const statusMap = {
        unpaid: "warning",
        printing: "primary",
        delivering: "info",
        completed: "success",
        cancelled: "danger",
      };
      return statusMap[status] || "info";
    },
    getStatusText(status) {
      const statusMap = {
        unpaid: "待支付",
        printing: "打印中",
        delivering: "配送中",
        completed: "已完成",
        cancelled: "已取消",
      };
      return statusMap[status] || "未知状态";
    },
    handleFilter() {
      this.currentPage = 1;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      // 当每页条数改变时，重置到第一页
      this.currentPage = 1;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    viewOrderDetail(order) {
      this.currentOrder = order;
      this.detailDialogVisible = true;
    },
    async handleOrder(order) {
      try {
        const result = await this.$confirm("确定要开始打印该订单吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });

        if (result !== "confirm") {
          this.$message.info("已取消操作");
          return;
        }

        const response = await fetch(
          `https://www.xiaoliangtongxue.cn/api/order/${order.id}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({
              state: "printing",
            }),
          }
        );

        if (!response.ok) {
          throw new Error("更新订单状态失败");
        }

        this.$message.success("订单状态已更新为打印中");
        await this.fetchOrders(); // 刷新订单列表
      } catch (error) {
        if (error.toString().includes("cancel")) {
          return;
        }
        console.error("处理订单失败:", error);
        this.$message.error("处理订单失败，请稍后重试");
      }
    },

    async completeOrder(order) {
      try {
        const result = await this.$confirm("确定要完成该订单吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });

        if (result !== "confirm") {
          this.$message.info("已取消操作");
          return;
        }

        const response = await fetch(
          `https://www.xiaoliangtongxue.cn/api/order/${order.id}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({
              state: "completed",
            }),
          }
        );

        if (!response.ok) {
          throw new Error("更新订单状态失败");
        }

        this.$message.success("订单已完成");
        await this.fetchOrders(); // 刷新订单列表
      } catch (error) {
        if (error.toString().includes("cancel")) {
          return;
        }
        console.error("完成订单失败:", error);
        this.$message.error("完成订单失败，请稍后重试");
      }
    },

    async startDelivery(order) {
      try {
        const result = await this.$confirm("确定要开始配送该订单吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });

        if (result !== "confirm") {
          this.$message.info("已取消操作");
          return;
        }

        const response = await fetch(
          `https://www.xiaoliangtongxue.cn/api/order/${order.id}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({
              state: "delivering",
            }),
          }
        );

        if (!response.ok) {
          throw new Error("更新订单状态失败");
        }

        this.$message.success("订单已开始配送");
        await this.fetchOrders(); // 刷新订单列表
      } catch (error) {
        if (error.toString().includes("cancel")) {
          return;
        }
        console.error("开始配送失败:", error);
        this.$message.error("开始配送失败，请稍后重试");
      }
    },

    async downloadFile(orderId) {
      try {
        // 这里需要调用后端的文件下载接口
        const response = await fetch(
          `https://www.xiaoliangtongxue.cn/api/download/${orderId}`,
          {
            credentials: "include",
          }
        );

        if (!response.ok) {
          throw new Error("文件下载失败");
        }

        // 获取文件blob
        const blob = await response.blob();

        // 创建下载链接
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `打印文件_订单${orderId}.pdf`; // 可以自定义文件名
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);

        this.$message.success("文件下载成功");
      } catch (error) {
        console.error("下载文件失败:", error);
        this.$message.error("下载文件失败，请稍后重试");
      }
    },
    async exportOrderReceipt(order) {
      try {
        // 生成小票内容
        const content = [
          "========= 打印订单小票 =========",
          `订单编号: ${order.orderId}`,
          `下单时间: ${order.createTime}`,
          `用户名称: ${order.userName}`,
          `用户手机号: ${order.phone}`,
          "----------------------------",
          `打印类型: ${order.printType === "black" ? "黑白" : "彩色"}`,
          `打印面数: ${order.page}`,
          `翻页方式: ${order.page === "双面" ? order.method : ""}`,
          `缩印方式: ${order.suoyin}`,
          `装订方式: ${order.binding}`,
          `纸张大小: ${order.paperSize}`,
          `纸张材质: ${order.paperMaterial}`,
          order.thick ? `纸张厚度: ${order.thick}` : null,
          `封面内容: ${
            order.fm_content
              ? order.fm_content === "空白"
                ? "空白封面"
                : order.fm_content === "首页"
                ? "文件首页为封面"
                : "文件首尾为封面封底"
              : "不添加封面"
          }`,
          order.fm_content ? `封面类型: ${order.fm_type}` : null,
          //order.fm_content ? `封面工艺: ${order.fm_method}` : null,
          `打印份数: ${order.copies} 份`,
          "----------------------------",
          `配送地址: ${order.deliveryAddress}`,
          `备注: ${order.note}`,
          "----------------------------",
          order.coupon_info
            ? [
                "优惠信息:",
                `优惠券码: ${order.coupon_info.code}`,
                order.coupon_info.type === "fixed"
                  ? `优惠金额: ¥${order.coupon_info.value.toFixed(2)}`
                  : `优惠折扣: ${(order.coupon_info.value / 10).toFixed(1)}折`,
                "----------------------------",
              ].join("\n")
            : "",
          `订单总价: ¥${order.totalPrice.toFixed(2)}`,
          `实付金额: ¥${order.pay.toFixed(2)}`,
          "=============================",
          `打印时间: ${new Date().toLocaleString()}`,
        ].join("\n");

        // 创建Blob对象
        const blob = new Blob([content], { type: "text/plain;charset=utf-8" });

        // 创建下载链接
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `打印小票_订单${order.orderId}.txt`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);

        this.$message.success("小票导出成功");
      } catch (error) {
        console.error("导出小票失败:", error);
        this.$message.error("导出小票失败，请稍后重试");
      }
    },
    async fetchOrders() {
      try {
        const response = await fetch(
          "https://www.xiaoliangtongxue.cn/api/order/self-pickup",
          {
            credentials: "include",
          }
        );
        const data = await response.json();
        console.log(data);

        // 转换数据格式
        const formattedOrders = data.map((order) => ({
          id: order.id, // 保留原始id
          orderId: order.id,
          userName: order.user_name,
          phone: order.phone,
          createTime: order.create_time,
          status: order.state,
          printType: order.color ? "color" : "black",
          printSide: order.page,
          thick: order.thick,
          paperSize: order.size,
          paperMaterial: order.material,
          copies: order.copies,
          deliveryAddress: order.address,
          totalPrice: order.price,
          page: order.page,
          binding: order.binding,
          method: order.method,
          fm_content: order.fm_content,
          fm_type: order.fm_type,
          fm_method: order.fm_method,
          suoyin: order.suoyin,
          files: [], // 后续需要添加文件处理
          coupon_info: order.coupon_info, // 添加优惠信息
          pay: order.pay,
          note: order.note,
        }));

        // 检查是否有新订单
        if (this.lastOrderCount > 0) {
          // 获取新订单 - 比较总数并检查ID是否存在于当前列表中
          const newOrders = formattedOrders.filter(
            (newOrder) =>
              !this.orderList.some(
                (existingOrder) => existingOrder.id === newOrder.id
              )
          );

          if (newOrders.length > 0) {
            // 播放提示音
            this.playNotificationSound();

            // 显示新订单提醒
            newOrders.forEach((order) => {
              this.$message({
                showClose: true,
                message: `新订单提醒：订单编号 ${order.orderId} 待处理`,
                duration: 0,
                type: "warning",
              });
            });
          }
        }

        this.orderList = formattedOrders;
        console.log(this.orderList);
        this.lastOrderCount = formattedOrders.length;
      } catch (error) {
        console.error("获取订单列表失败:", error);
        this.$message.error("获取订单列表失败，请稍后重试");
      }
    },
  },
};
</script>

<style scoped>
.header {
  text-align: center;
  position: relative;
  padding-bottom: 16px;
}

.header h1 {
  color: #000000;
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 1px;
}

.header .el-button--primary {
  position: absolute;
  right: 0;
  top: 0;
}

/* 表格样式 */
:deep(.el-table) {
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  flex: 1;
  --el-table-border-color: #000000;
  --el-table-header-bg-color: #ffffff;
  margin-bottom: 16px;
}

:deep(.el-table--border::after),
:deep(.el-table--group::after),
:deep(.el-table::before) {
  background-color: #000000;
}

:deep(.el-table__inner-wrapper::before) {
  background-color: #000000;
}

/* 表头样式 */
:deep(.el-table__header th) {
  background-color: var(--el-table-header-bg-color);
  color: #000000;
  font-weight: 600;
  height: 50px;
  padding: 8px 0;
  text-align: center;
}

/* 表格内容样式 */
:deep(.el-table__body td) {
  padding: 12px 0;
  color: #333333;
  text-align: center;
}

:deep(.el-table__body tr:hover > td) {
  background-color: #f5f5f5 !important;
}

/* 调整表格底部间距 */
:deep(.el-table__body-wrapper) {
  overflow-x: auto !important;
  height: calc(100% - 47px) !important;
  margin-bottom: 0;
}

:deep(.el-table__fixed-right) {
  height: 100% !important;
  background-color: #fff;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.12);
}

/* 状态筛选下拉框样式 */
:deep(.el-table__header .el-select) {
  margin-left: 8px;
}

:deep(.el-table__header .el-input__inner) {
  height: 24px;
  line-height: 24px;
}

/* 状态标签样式 */
:deep(.el-tag) {
  padding: 4px 12px;
  border-radius: 4px;
  font-weight: 500;
  border: 1px solid #000000;
  background-color: #ffffff;
  color: #000000;
}

:deep(.el-tag--warning) {
  background-color: #ffffff;
  color: #000000;
  border-color: #000000;
}

:deep(.el-tag--primary) {
  background-color: #ffffff;
  color: #000000;
  border-color: #000000;
}

:deep(.el-tag--info) {
  background-color: #ffffff;
  color: #000000;
  border-color: #000000;
}

:deep(.el-tag--success) {
  background-color: #ffffff;
  color: #000000;
  border-color: #000000;
}

:deep(.el-tag--danger) {
  background-color: #ffffff;
  color: #000000;
  border-color: #000000;
}

/* 操作按钮样式 */
.operation-buttons {
  display: flex;
  gap: 8px;
  justify-content: center;
}

:deep(.el-button) {
  padding: 6px 16px;
  font-weight: 500;
  border-radius: 4px;
  transition: all 0.3s;
  background-color: #ffffff;
  border: 1px solid #000000;
  color: #000000;
}

:deep(.el-button:hover) {
  transform: translateY(-1px);
  background-color: #000000;
  color: #ffffff;
}

.operation-buttons :deep(.el-button--primary) {
  background-color: #000000;
  border-color: #000000;
  color: #ffffff;
}

.operation-buttons :deep(.el-button--primary:hover) {
  background-color: #333333;
  border-color: #333333;
}

.operation-buttons :deep(.el-button--success) {
  background-color: #000000;
  border-color: #000000;
  color: #ffffff;
}

.operation-buttons :deep(.el-button--success:hover) {
  background-color: #333333;
  border-color: #333333;
}

/* 分页器样式 */
.pagination-container {
  margin-top: 0;
  padding: 12px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid #000000;
}

.pagination-container :deep(.el-pagination) {
  justify-content: center;
  font-weight: normal;
}

.pagination-container :deep(.el-pagination__total),
.pagination-container :deep(.el-pagination__sizes) {
  margin-right: 16px;
  line-height: 28px;
  color: #333333;
}

.pagination-container :deep(.el-pager li) {
  border-radius: 4px;
  line-height: 28px;
  color: #333333;
}

.pagination-container :deep(.el-pager li.is-active) {
  background-color: #000000;
  color: #ffffff;
  font-weight: bold;
}

.pagination-container :deep(.el-pager li:hover) {
  color: #000000;
}

.el-main {
  padding: 20px;
  display: flex;
  flex-direction: column;
}

.all-orders-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.file-list {
  margin-top: 20px;
  padding: 16px;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #d0d0d0;
}

.file-list h3 {
  margin: 0 0 16px 0;
  color: #000000;
}

.file-operations {
  display: flex;
  gap: 12px;
}

/* 导出按钮样式 */
.header :deep(.el-button--primary) {
  background-color: #000000;
  border-color: #000000;
  color: #ffffff;
}

.header :deep(.el-button--primary:hover) {
  background-color: #333333;
  border-color: #333333;
}

/* 对话框样式 */
:deep(.el-dialog) {
  border: 2px solid #000000;
  border-radius: 8px;
}

:deep(.el-dialog__body) {
  background-color: #ffffff;
}

:deep(.el-descriptions) {
  --el-descriptions-border-color: #000000;
}

:deep(.el-descriptions__label) {
  background-color: #f5f5f5;
  color: #000000;
}

:deep(.el-descriptions__content) {
  color: #333333;
}
</style>